import { Slider,} from '@material-ui/core';
import Button from "@components/common/button/Button";
import * as React from 'react';
import AvatarEditor from 'react-avatar-editor';
import * as FileActions from '@services/file/file.actions';
import TranslateNew from '@translate/TranslateNew';
import { IStuffBeingUploaded, IFinishedUpload,IUploadFile } from '@app-types/websocket/file.types';
import { connect } from 'react-redux';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import {displayErrorMessage} from '@services/user/user.actions';
import { handleBlobUpload, fileToBase64 } from '@helpers/uploadHelper';
import { styleColors } from 'src/main.style';

const tn :TranslateNew = TranslateNew.getInstance();



interface IProps {
  uploadingFiles: IStuffBeingUploaded[];
  uploadedFiles: IFinishedUpload[];
  uploadFile:(file: IUploadFile) => void;
  uploadedFileUsed: (file: number) => void;
  close: () => void;
  saveFileIdToAccount: (fileId:number) => void;
  displayErrorMessage: (msg: string) => void;
  startImageURL: string;
}

interface IState {
  scale:number;
  saveClicked:boolean;
  dataURL: string;
  internalUploadId: number|null;
}

class CreateAvatar extends React.Component<IProps, IState> {
  private editorRef: React.RefObject<AvatarEditor>;
  private inputRef: React.RefObject<HTMLInputElement>;

  constructor(props: IProps) {
    super(props);
    this.editorRef = React.createRef();
    this.inputRef = React.createRef<HTMLInputElement>();
    this.state = {
      scale:100,
      saveClicked:false,
      dataURL: '',
      internalUploadId:null,
    };
  }

  public componentDidUpdate(oldProps:IProps) {
    for (const file of this.props.uploadedFiles) {
      if (this.state.internalUploadId !== null && file.internalId === this.state.internalUploadId) {
        this.props.uploadedFileUsed(file.id);
        if (file.id) {
          this.props.saveFileIdToAccount(file.id);
        }
      }
    }
  }

  public render() {

    return (<>
      <label htmlFor="add-file-direct" 
        onClick={() => {if (this.inputRef.current) {this.inputRef.current.focus();}}}
        style={{display: 'flex', alignItems: 'center', backgroundColor: styleColors.greyLight3, padding: '3px 14px', borderRadius: '20px',
        color: styleColors.greyDark1, fontSize: '16px', fontWeight: 500, position: 'relative'}}>
        <input type="file" ref={this.inputRef} multiple={false} style = {{opacity:0, position: 'absolute', width:'80%'}} id={"add-file-direct"} 
          onChange={this.handleImageUpload} accept="capture=camera,image/*"/>
        <ImageOutlinedIcon onClick={() => {if (this.inputRef.current) {this.inputRef.current.focus();}}} 
          style={{fill:styleColors.greyDark1, paddingRight: '5px'}}/>
        <div onClick={() => {if (this.inputRef.current) {this.inputRef.current.focus();}}} style= {{whiteSpace: 'nowrap'}}>
          {tn.lang.settingsPickImage}
        </div>
      </label>
      
      <div style={{width:'100%', textAlign: 'center', position:'relative'}}>
        <AvatarEditor
          ref={this.editorRef}
          image={this.state.dataURL !== ''?this.state.dataURL:this.props.startImageURL}
          style={{ width: "100%", height: "100%", maxWidth: "512px", maxHeight: "512px" }}
          border={10}
          borderRadius={200}
          color={[255, 255, 255, 1]}
          scale={this.state.scale/100}
          rotate={0}
        />
      </div>
      <Slider
        min={100}
        max={300}
        defaultValue={this.state.scale}
        value={this.state.scale}
        onChange={ (e, val) => this.setState({scale:(typeof(val) === 'number'?val:val[0]) }) } 
      />
      <Button variant='contained' color='primary' onClick={() => {
        if (this.editorRef.current) {

          this.setState({saveClicked:true});

          try {


            const canvas = document.createElement('canvas');
              canvas.width = 512;
              canvas.height = 512;

            const context = canvas.getContext('2d');
            const areaLimit = (this.editorRef.current.getImage().width > 4095 || this.editorRef.current.getImage().height > 4095);

            if (context !== null) {
              context.drawImage(areaLimit 
                ? this.editorRef.current.getImageScaledToCanvas() 
                : this.editorRef.current.getImage(), 0, 0, 512, 512);
            }

            canvas.toBlob((blob) => {
              if(blob && this.editorRef.current){
                const d = handleBlobUpload(blob, "avatar.png", this.props.uploadFile);
                this.setState({internalUploadId: d.internalId})
              }
            })
          } catch (e) {
            this.props.displayErrorMessage("Image upload failed");
            this.setState({saveClicked:false, internalUploadId:null});
            return;
          }
        }

        }}
        disabled={this.state.saveClicked}>
        {this.state.saveClicked?tn.lang.uploading:tn.lang.save}
      </Button>
      <Button variant='contained' style={{marginBottom:20}} onClick={() => this.props.close()}>
        {tn.lang.cancel}
      </Button>
    </>
    );
  }

  private handleImageUpload = async (event: any) => {
    try {
      const { files } = event.target;
      if (files && files.length > 0 || (event.files && event.files.length > 0)) {
        const f:File = files.item(0) ? files.item(0) : event.files.item(0);
        if (f.type && f.type.toLowerCase().includes("image")) {
          const data = await fileToBase64(f);
          this.setState({dataURL:  'data:'+f.type+';base64,'  + data});
        } else if (f.type && f.type.toLowerCase().includes("video")) {
          this.props.displayErrorMessage("Videos not supported yet");
        }
      }
    } catch (error) {
      console.error("Failed to read selected avatar image", error);
      this.props.displayErrorMessage("Could not read the selected image. Please try another image.");
    }
  }


}

function mapStateToProps(state: any) {

  return {
    uploadingFiles: state.file.uploadSlots,
    uploadedFiles: state.file.uploadedFiles,
  };
}

const mapDispatchToProps = {
  uploadFile: FileActions.requestFileUpload,
  uploadedFileUsed: FileActions.uploadedFileUsed,
  displayErrorMessage,
};

export default connect(mapStateToProps,mapDispatchToProps)(CreateAvatar);



// WEBPACK FOOTER //
// ./src/components/extended-family/update-family-member/createAvatar.tsx